import Swal from 'sweetalert2';

// Custom SweetAlert2 configuration
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  }
});

// Success notification
export const showSuccess = (message, title = 'Başarılı!') => {
  return Toast.fire({
    icon: 'success',
    title: title,
    text: message
  });
};

// Error notification
export const showError = (message, title = 'Hata!') => {
  return Toast.fire({
    icon: 'error',
    title: title,
    text: message
  });
};

// Warning notification
export const showWarning = (message, title = 'Uyarı!') => {
  return Toast.fire({
    icon: 'warning',
    title: title,
    text: message
  });
};

// Info notification
export const showInfo = (message, title = 'Bilgi') => {
  return Toast.fire({
    icon: 'info',
    title: title,
    text: message
  });
};

// Confirmation dialog
export const showConfirm = async (message, title = 'Emin misiniz?') => {
  return await Swal.fire({
    title: title,
    text: message,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#1f2937',
    cancelButtonColor: '#6b7280',
    confirmButtonText: 'Evet, eminim!',
    cancelButtonText: 'İptal',
    customClass: {
      confirmButton: 'swal2-confirm-custom',
      cancelButton: 'swal2-cancel-custom'
    }
  });
};

// Delete confirmation
export const showDeleteConfirm = async (itemName = 'bu öğeyi') => {
  return await Swal.fire({
    title: 'Silmek istediğinize emin misiniz?',
    text: `${itemName} kalıcı olarak silinecek!`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#ef4444',
    cancelButtonColor: '#6b7280',
    confirmButtonText: 'Evet, sil!',
    cancelButtonText: 'İptal',
    customClass: {
      confirmButton: 'swal2-delete-confirm',
      cancelButton: 'swal2-cancel-custom'
    }
  });
};

// Loading dialog
export const showLoading = (message = 'Yükleniyor...') => {
  return Swal.fire({
    title: message,
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });
};

// Close loading
export const closeLoading = () => {
  Swal.close();
};

// Custom dialog
export const showDialog = (config) => {
  return Swal.fire({
    confirmButtonColor: '#1f2937',
    cancelButtonColor: '#6b7280',
    customClass: {
      confirmButton: 'swal2-confirm-custom',
      cancelButton: 'swal2-cancel-custom',
      ...config.customClass
    },
    ...config
  });
};

// Input dialog
export const showInput = async (title, inputType = 'text', inputPlaceholder = '') => {
  return await Swal.fire({
    title: title,
    input: inputType,
    inputPlaceholder: inputPlaceholder,
    showCancelButton: true,
    confirmButtonColor: '#1f2937',
    cancelButtonColor: '#6b7280',
    confirmButtonText: 'Tamam',
    cancelButtonText: 'İptal',
    customClass: {
      confirmButton: 'swal2-confirm-custom',
      cancelButton: 'swal2-cancel-custom'
    },
    inputValidator: (value) => {
      if (!value) {
        return 'Bu alan boş bırakılamaz!';
      }
    }
  });
};

export default {
  showSuccess,
  showError,
  showWarning,
  showInfo,
  showConfirm,
  showDeleteConfirm,
  showLoading,
  closeLoading,
  showDialog,
  showInput
};

